export function parseNDJSON(): TransformStream<string, any> {
  let ndjsonBuffer = "";

  return new TransformStream<string, any>({
    transform: (ndjsonChunk, controller) => {
      ndjsonBuffer += ndjsonChunk;

      const jsonValues = ndjsonBuffer.split("\n");
      jsonValues.slice(0, -1).forEach((jsonValue) => {
        controller.enqueue(JSON.parse(jsonValue));
      });

      ndjsonBuffer = jsonValues[jsonValues.length - 1];
    },
    flush: (controller) => {
      if (ndjsonBuffer) {
        controller.enqueue(JSON.parse(ndjsonBuffer));
      }
    },
  });
}

export async function* readableStreamToAsyncGenerator<T>(
  readableStream: ReadableStream<T>,
  signal?: AbortSignal,
): AsyncGenerator<T> {
  const reader = readableStream.getReader();
  let streamFinished = false;
  const onAbort = () => {
    reader.cancel();
  };
  signal?.addEventListener("abort", onAbort);
  try {
    while (true) {
      const { value, done } = await reader.read();
      signal?.throwIfAborted();
      if (done) {
        streamFinished = true;
        return;
      }
      yield value!;
    }
  } finally {
    reader.releaseLock();
    signal?.removeEventListener("abort", onAbort);
    if (!signal?.aborted && !streamFinished) {
      readableStream.cancel();
    }
  }
}

export function concat<T>(...streams: ReadableStream<T>[]): ReadableStream<T> {
  const { readable, writable } = new TransformStream<T, T>();

  streams.reduce(
    (finished, stream, i, arr) =>
      finished.then(() =>
        stream.pipeTo(writable, { preventClose: i !== arr.length - 1 }),
      ),
    Promise.resolve(),
  );
  return readable;
}
